<template>
    <section  class="px-content py-20 xl:pt-[120xp] xl:pb-60px relative will-change" :class="computedClass" :data-scroll-section="inner == 'false'">
        <div class="flex flex-col items-center justify-center mb-16" data-scroll data-scroll-class="xyz-in" xyz="fade down duration-15">
            <h2 class="text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <p class="xl:max-w-[40vw] text-center" v-show="blockData.text" v-html="blockData.text"></p>
        </div>

        <ul class="tabs__nav mb-14">
            <li class="px-16 text-xl leading-snug flex flex-col"
                :class="{'active text-navy-blue-01' : activeCategory === category, 'text-navy-blue-03' : activeCategory !== category}"
                v-for="(category, index) in teamCategories"
                :key="index"
                @click="activeCategory = category"
            >
                <div class="cursor-pointer">{{ category.name }}</div>
            </li>
        </ul>

        <!-- card list -->
        <div class="grid md:grid-cols-2  xl:grid-cols-3 gap-4 xl:gap-6">

            <!-- card -->
            <div class="card overflow-hidden" v-show="filteredTeamMembers" v-for="(member, index) in filteredTeamMembers" :key="index">

                <!-- front -->
                <div class="card__face card__face--front relative flex flex-col items-center bg-white  pb-16 h-full">
                    <div class="flex items-center justify-center p-10">
                        <img class="border-4 border-light-blue-01 rounded-full" v-show="member.data.fields.image" :src="member.data.fields.image.url" :alt="member.data.fields.image.alt">
                    </div>
                    <h4 class="text-2xl tracking-[1px] text-center mb-5 px-10" v-show="member.title.rendered">{{ member.title.rendered }}</h4>
                    <div class="text-center mb-12 px-10" v-show="member.data.fields.position_company" v-html="member.data.fields.position_company"></div>
                    <div class="bg-light-blue-01 w-[70px] h-1"></div>
                </div>
                <!-- ./front -->

                <!-- back -->
                <div class="card__face card__face--back flex flex-col items-center bg-light-blue-01 text-navy-blue-01 p-10" v-if="member.data.fields.about">
                    <img class="mb-12" :src="endpoints.template_url + '/assets/img/lb-black.svg'" alt="Lustica Bay logo">
                    <div class="scrollMe font-canela text-base mb-5 xl:mb-12 text-center overflow-auto"  v-html="member.data.fields.about" ></div>
                    <div class="bg-navy-blue-01 w-[70px] h-1 mt-auto mx-auto"></div>
                </div>
                <!-- ./back -->

            </div>
            <!-- ./card -->

        </div>
        <!-- ./card list -->
    </section>
</template>


<script>
    export default {
        name: 'TeamCards',
        data() {
            return {
                teamMembers: false,
                teamCategories: false,

                activeCategory: false,

                cardOne: "start"
            }
        },
        mounted() {
            this.getTeamMembers()

            //window.addEventListener('load', (event) => {
            
            /* this.$nextTick( () => {
                let scrollMe = this.$el.querySelectorAll('.card');
                console.log(scrollMe);
                scrollMe.forEach( el =>{
                    console.log(el);
                    el.addEventListener('mouseenter', (e) => {
                        this.$root.scroll.stop()
                    })
                    el.addEventListener('mouseleave', (e) => {
                        this.$root.scroll.start()
                    })

                })
            } ) */

            //})
        },
        computed: {
            filteredTeamMembers () {
                let results = this.teamMembers
                if ( this.activeCategory.id && this.teamMembers ) {
                    results =  results.filter( member => {
                        if ( member.team_category.includes(this.activeCategory.id) ) { return member }
                    })
                }
                this.updateScroll()
                return results
            },
            computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'white' ) {
                    className = [
                        'bg-transparent',
                    ]
                }
                if ( this.blockData.background_color === 'light-blue' ) {
                    className = [
                        'bg-light-blue-03',
                    ]
                }
                if ( this.blockData.background_color === 'dark-blue' ) {
                    className = [
                        'bg-navy-blue-01',
                    ]
                }
                return className;
            }
        },
        methods: {
            getTeamMembers() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/team_member?per_page=100' )
                    .then( res => {
                        this.teamMembers = res.data
                        this.getTeamCategories()
                        this.$nextTick( () => {
                            let scrollMe = this.$el.querySelectorAll('.card');
                            scrollMe.forEach( el =>{
                                el.addEventListener('mouseenter', (e) => {
                                    this.$root.scroll.stop()
                                })
                                el.addEventListener('mouseleave', (e) => {
                                    this.$root.scroll.start()
                                })

                            })
                        } )
                    }
                );
            },
            getTeamCategories() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/team_category' )
                    .then( res => {
                        this.teamCategories = res.data
                        this.activeCategory = this.teamCategories[0]
                        this.updateScroll()
                    }
                );
            },
            goToLocation(card) {
                window.location.href = card.cta.url;
            },
            openBlank: function (link) {
                window.open(link, "_blank");
            },
            updateScroll() {
                /*this.$nextTick(() => {
                    setTimeout(() => {
                        this.$root.scroll.update()
                    }, 200);
                });*/
            }
        },
    }
</script>
